import _ from 'lodash'
import Backbone from 'backbone'
import template from './add-license.hbs'
import LicenseActivation from './license-activation'
import appDisplay from 'scoreboard/components/app-display'
import FormView from 'scoreboard/components/form-view'
import SuccessDialog from 'scoreboard/components/success-dialog'
import i18n from 'scoreboard/components/i18n'
import FileDrop from 'scoreboard/components/files/file-drop'
import BusyButton from 'scoreboard/components/busy-button'

/**
 * Dialog displayed when clicking "Add License" on the license management
 * screen.
 */

var AddLicense = Backbone.View.extend({

	// this.options.unlinkedDatabases is an array of the unlinked databases

	tagName: 'form',

	className: 'add-license',

	initialize: function(options) {
		this.options = options || {}
		this.formView = new FormView({ el: this.el })
	},

	render: function() {
		this.$el.empty().append(template())
		this._renderFileDrop()
		this._renderBusyButton()
		this._attachListeners()
		this.formView.start()
		return this
	},

	_renderFileDrop: function() {
		_.invoke(this.fileDrop, 'remove')
		this.fileDrop = new FileDrop({
			fileUploaderOptions: {
				url: 'api/admin/licenses'
			}
		})
		this.$('.dialog-body-content').append(this.fileDrop.el)
		this.fileDrop.render()
	},

	_renderBusyButton() {
		this.busyButton = new BusyButton({ el: this.$('.button-primary') })
	},

	_attachListeners() {
		this.fileDrop.on('done', data => this.uploadFinished(data))
			.on('error', xhr => this.uploadError(xhr))
			.on('start', () => {
				this.formView.clearErrors()
				this.formView.change()

				// #34716 As a means of some kind of loading indicator, use a busy button
				// while the license is being processed on the backend.
				this.$('.button.cancel').addClass('is-not-displayed')
				this.busyButton.$el.removeClass('is-not-displayed')
				this.busyButton.loading()
			})
	},

	uploadFinished: function(license) {
		if (license.activated) {
			// License already activated, close dialog
			this.trigger('done')
		} else if (license.pendingOrbApproval) {
			// License sent to Orb, Spider Support will approve
			appDisplay.replaceDialog(new SuccessDialog({
				title: i18n.get('admin.licenses.activation.orb'),
				message: i18n.get('admin.licenses.activation.orb.message')
			}))
		} else {
			// User must get answer key from support manually
			var licenseActivation = new LicenseActivation({
				license: license,
				unlinkedDatabases: this.options.unlinkedDatabases
			})
			appDisplay.replaceDialog(licenseActivation)
			licenseActivation.on('done', this.trigger.bind(this, 'activate:license'))
		}
		// note if the license wasn't activated, this won't close the dialog
		// because the dialog will be listening for events on LicenseActivation
		// instead of on this view
		Backbone.trigger('add:license', license)
	},

	uploadError: function(xhr) {
		this.formView.error(xhr)
		this.$('.button.cancel').removeClass('is-not-displayed')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.fileDrop], 'remove')
	}

})

export default AddLicense

AddLicense.__filename__ = 'admin/licenses/add-license.js'
